var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { width as styledWidth, display as styledDispay, space, color, order, maxWidth, minWidth, alignItems, justifyContent, flexWrap, boxShadow, } from 'styled-system';
var GridWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  width: 100%;\n\n  ", ";\n  ", ";\n  ", ";\n"])), color, minWidth, boxShadow);
GridWrapper.defaultProps = {
    bg: 'white',
    minWidth: 0,
};
export var FullWidthBoxShadow;
(function (FullWidthBoxShadow) {
    FullWidthBoxShadow["BOTTOM"] = "bottom";
})(FullWidthBoxShadow || (FullWidthBoxShadow = {}));
export var FlexJustifyContent;
(function (FlexJustifyContent) {
    FlexJustifyContent["CENTER"] = "center";
    FlexJustifyContent["SPACE_BETWEEN"] = "space-between";
})(FlexJustifyContent || (FlexJustifyContent = {}));
export var FlexAlignItems;
(function (FlexAlignItems) {
    FlexAlignItems["CENTER"] = "center";
    FlexAlignItems["START"] = "flex-start";
})(FlexAlignItems || (FlexAlignItems = {}));
export var FlexWrap;
(function (FlexWrap) {
    FlexWrap["WRAP"] = "wrap";
    FlexWrap["NO_WRAP"] = "nowrap";
})(FlexWrap || (FlexWrap = {}));
// S (320-631):
// - total area (content area + offset): 320px
// - content area: 288px
// - offset: 16px
// - gutter: 16px
// - column: 60px
// - 4 columns
// M (632-983):
// - total area (content area + offset): 632px
// - content area: 584px
// - offset: 24px
// - gutter: 24px
// - column: 52px
// - 8 columns
// L (984-1391):
// - total area (content area + offset): 984px
// - content area: 888px
// - offset: 48px
// - gutter: 24px
// - column: 52px
// - 12 columns
// XL (1392-1600):
// - total area (content area + offset): 1392px
// - content area: 1264px
// - offset: 64px
// - gutter: 32px
// - column: 76px
// - 12 columns
var GridContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n\n  display: flex;\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n\n  display: flex;\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), flexWrap, alignItems, justifyContent, maxWidth, space);
GridContainer.defaultProps = {
    mx: 'auto',
    px: [2, '12px', '36px', 6],
    maxWidth: 0,
    flexWrap: 'wrap',
};
export var Grid = function (_a) {
    var bg = _a.bg, children = _a.children, legacyShopRebootMaxWidth = _a.legacyShopRebootMaxWidth, fullWidthBoxShadow = _a.fullWidthBoxShadow, props = __rest(_a, ["bg", "children", "legacyShopRebootMaxWidth", "fullWidthBoxShadow"]);
    return (React.createElement(GridWrapper, { bg: bg, boxShadow: fullWidthBoxShadow },
        React.createElement(GridContainer, __assign({ maxWidth: legacyShopRebootMaxWidth ? [null, null, '1064px', '1096px'] : 0 }, props), children)));
};
Grid.propTypes = {
    /** Grid wrapper background color */
    bg: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.array,
    ]),
    /** Grid content */
    children: PropTypes.node,
    /** Box shadow that will be applied to the fill width of the container */
    fullWidthBoxShadow: boxShadow.propTypes.boxShadow,
    /**
     * Adjusts the grid to match with shop reboot max width on desktop (default: false)
     *
     * TODO: Intermediate solution. We will cap max width for GN at the current
     * desktop size to make grid as aligned to the current one as possible but still
     * have the defined offsets and gutters
     */
    legacyShopRebootMaxWidth: PropTypes.bool,
};
Grid.defaultProps = {
    legacyShopRebootMaxWidth: false,
};
var GridItemContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  flex: none;\n  box-sizing: border-box;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: block;\n  flex: none;\n  box-sizing: border-box;\n\n  ", ";\n  ", ";\n  ", ";\n"])), space, styledWidth, order);
GridItemContainer.defaultProps = {
    width: 1,
    px: [2, '12px', null, 3],
};
export var GridItem = function (_a) {
    var w = _a.w, width = _a.width, props = __rest(_a, ["w", "width"]);
    return React.createElement(GridItemContainer, __assign({ width: width || w }, props));
};
GridItem.defaultProps = {
    w: 1,
};
GridItem.propTypes = __assign({ 
    /** GridItem width in percentage (max: 1, default: 1) */
    w: styledWidth.propTypes.width }, styledWidth.propTypes);
var Border = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n\n  width: 100%;\n  height: 1px;\n  margin-top: -1px;\n\n  ", ";\n"], ["\n  ", ";\n\n  width: 100%;\n  height: 1px;\n  margin-top: -1px;\n\n  ", ";\n"])), styledDispay, color);
Border.defaultProps = {
    bg: 'gray.4',
    display: 'block',
};
/**
 * Creates a zero-height border in the grid where the border width is
 * matching the grid content width
 */
export var GridItemBorder = function (_a) {
    var w = _a.w, width = _a.width, display = _a.display;
    return (React.createElement(GridItem, { w: w, width: width },
        React.createElement(Border, { display: display })));
};
GridItemBorder.propTypes = __assign(__assign({ 
    /** GridItem width in percentage (max: 1, default: 1) */
    w: styledWidth.propTypes.width }, styledWidth.propTypes), styledDispay.propTypes);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
